import { EditorialImageApiModel, LayoutObjectApiModel } from '@cxb/editor-stb-api';
import { PageItemWithCountries } from './page-item';
import { TrayWithLocalizedTitle } from './tray-common';

export type BuiltInItemDomainModel =
  | FavouriteChannels
  | YourReminders
  | ContinueWatching
  | Watchlist
  | ContinueWatchingCarousel
  | WatchlistCarousel
  | TVGuide
  | WatchlistOnDemand
  | PrimeVideoRecommendations
  | ContinueWatchingOndemand;

export interface BuiltInCommon extends PageItemWithCountries, TrayWithLocalizedTitle {
  type: 'BuiltIn';
  cardBackgroundImage?: EditorialImageApiModel;
  displayServiceTypeIcon: boolean;
  dthSubStatusIds: string[];
  scheduledFrom?: number;
  scheduledTo?: number;
  layout?: LayoutObjectApiModel;
}

export enum DomainBuiltInItemType {
  FavouriteChannels = 'FavouriteChannels', // AXB-71
  YourReminders = 'YourReminders', // AXB-84
  ContinueWatching = 'ContinueWatching', // AXB-79
  ContinueWatchingOndemand = 'ContinueWatchingOnDemand', // MYX-86
  Watchlist = 'Watchlist', // AXB-80
  TVGuide = 'TVGuide', // AXB-78
  WatchlistCarousel = 'WatchlistCarousel', //AXB-908
  WatchlistOnDemand = 'WatchlistOnDemand',
  PrimeVideoRecommendations = 'PrimeVideoRecommendations',
  ContinueWatchingCarousel = 'ContinueWatchingCarousel', //AXB-909
}

export interface FavouriteChannels extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.FavouriteChannels;
}

export interface YourReminders extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.YourReminders;
}

export interface ContinueWatching extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.ContinueWatching;
}

export interface Watchlist extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.Watchlist;
}

export interface ContinueWatchingCarousel extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.ContinueWatchingCarousel;
}

export interface WatchlistCarousel extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.WatchlistCarousel;
}

export interface TVGuide extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.TVGuide;
}

export interface WatchlistOnDemand extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.WatchlistOnDemand;
}

export interface PrimeVideoRecommendations extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.PrimeVideoRecommendations;
}

export interface ContinueWatchingOndemand extends BuiltInCommon {
  builtInType: DomainBuiltInItemType.ContinueWatchingOndemand;
}
